import PropTypes from 'prop-types';

import DimensionAttributionDetails from './DimensionAttributionDetails';

function ColumnAttributionDetails({
  attribution,
}) {
  const attr = attribution;
  attr.authorOrganizations = [attribution.authorOrganization];
  attr.dataTableTitles = [attribution.dataTableTitle];
  attr.sourceNames = [attribution.sourceName];
  attr.sourceLinks = [attribution.sourceLink];
  attr.timeLongNames = [attribution.timeLongName];
  attr.publishedDates = [new Date(attribution.publishedDate)];
  attr.sourceTables = [attribution.sourceTable];
  attr.universes = [attribution.universe];

  return (
    <DimensionAttributionDetails
      attribution={attr}
    />
  );
}

ColumnAttributionDetails.propTypes = {
  attribution: PropTypes.shape({
    authorOrganization: PropTypes.string,
    calculationMethodology: PropTypes.string,
    dataTableTitle: PropTypes.string,
    description: PropTypes.string,
    featureClasses: PropTypes.arrayOf(PropTypes.number),
    publishedDate: PropTypes.string,
    sourceLink: PropTypes.string,
    sourceName: PropTypes.string,
    sourceTable: PropTypes.string,
    supportsCustomGeographies: PropTypes.bool,
    timeLongName: PropTypes.string,
    universe: PropTypes.string,
  }),
};

ColumnAttributionDetails.defaultProps = {
  attribution: null,
};

export default ColumnAttributionDetails;
